import type { ReactNode } from "react";
import { usePageHeader } from "../../../components/shell/PageHeaderContext";
import { useLendingOverview } from "../../../lib/queries";
import { SubNav } from "../shared";

export const LENDING_BASE = "/admin/peso-a-peso";

/** Section tabs of the Peso a Peso panel. Pass `title` to also set the topbar; omit when the inner page does it. */
export function LendingTabs() {
  const overview = useLendingOverview();
  const data = overview.data;
  return (
    <div className="page-container tabs-only">
      <SubNav
        ariaLabel="Secciones de Peso a Peso"
        items={[
          { to: LENDING_BASE, label: "Resumen", end: true },
          { to: `${LENDING_BASE}/solicitudes`, label: "Solicitudes", count: data ? data.byStatus.submitted.count + data.byStatus.in_review.count : null },
          { to: `${LENDING_BASE}/aliados`, label: "Revisores", count: data?.reviewers.filter((reviewer) => reviewer.status === "active").length ?? null },
          { to: `${LENDING_BASE}/configuracion`, label: "Configuración" }
        ]}
      />
    </div>
  );
}

export function LendingFrame({ title, subtitle, actions, children }: { title: string; subtitle: string; actions?: ReactNode; children: ReactNode }) {
  usePageHeader(title, subtitle, actions);
  return (
    <>
      <LendingTabs />
      <div className="page-container after-tabs">{children}</div>
    </>
  );
}
